enum I18nKey {
    GameNotificationTurn = 'GameNotificationTurn',
    GameNotificationTurnTitle = 'GameNotificationTurnTitle',
    GameNotificationEliminated = 'GameNotificationEliminated',
    GameNotificationEliminatedTitle = 'GameNotificationEliminatedTitle',
    GameNotificationInvite = 'GameNotificationInvite',
    GameNotificationInviteTitle = 'GameNotificationInviteTitle',
    GameNotificationNotifyCreator = 'GameNotificationNotifyCreator',
    GameNotificationNotifyCreatorTitle = 'GameNotificationNotifyCreatorTitle',
    GameNotificationTeamChatMessage = 'GameNotificationTeamChatMessage',
    GameNotificationChatMessage = 'GameNotificationChatMessage',
    GameNotificationChatMessageTitle = 'GameNotificationChatMessageTitle',
};

export default I18nKey;
